import React, { useState } from "react";
import { Pagination } from "rsuite";
import { numberFormatter } from "../../utils";

const ParametricMaterialTable = (props: any) => {
	const [limit, setLimit] = React.useState(10);

	return (
		<>
			<table className="common-table-ui">
				<thead>
					<tr>
						<th>Material Number</th>
						<th>2023 PO Spend</th>
						<th>Actual Unit Cost</th>
						<th>Modelled Unit Price</th>
						<th>% Cost Reduction</th>
						<th>Benefit</th>
					</tr>
				</thead>
				<tbody>
					{Array.isArray(props.data) &&
						props?.data?.map((d: any, index: any) => {
							return (
								<tr key={index + d.master_vendor_name}>
									<td>{d.MaterialNumber}</td>
									<td>
										{numberFormatter(
											d.ThisYear_Spend,
											2,
											"$"
										)}
									</td>
									<td>
										{numberFormatter(
											d.actualUnitCost,
											2,
											"$"
										)}
									</td>
									<td>
										{numberFormatter(
											d.modelledUnitPrice,
											2,
											"$"
										)}
									</td>
									<td>
										{numberFormatter(d.costReduction, 0)}%
									</td>
									<td>
										{numberFormatter(d.benifit, 0, "$")}
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
			<div className="pagination-component">
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={5}
					size="xs"
					layout={["-", "pager", "skip"]}
					total={props.count}
					limit={limit}
					activePage={props.pageNumber}
					onChangePage={(e) => {
						props.updatePageNumber(e);
					}}
				/>
			</div>
		</>
	);
};
export default ParametricMaterialTable;
